import { useFontSize } from '@/shared/hooks/useFontSize';
import { FONT_SIZE_DEFAULT_PX } from '@/shared/constants/font-size';

export default function FontSizeControl() {
  const { sizePx, decrease, increase, reset, isDefault, canDecrease, canIncrease } =
    useFontSize();

  return (
    <div className="font-size-control" role="group" aria-label="Tamanho da fonte">
      <button
        type="button"
        className="font-size-control__btn font-size-control__btn--sm"
        onClick={decrease}
        disabled={!canDecrease}
        title={`Diminuir fonte.`}
        aria-label="Diminuir fonte"
      >
        A−
      </button>
      <button
        type="button"
        className={`font-size-control__reset${isDefault ? ' font-size-control__reset--active' : ''}`}
        onClick={reset}
        disabled={isDefault}
        title={`Tamanho médio (${FONT_SIZE_DEFAULT_PX}px)`}
        aria-label="Restaurar tamanho médio da fonte"
      >
        Média
      </button>
      <button
        type="button"
        className="font-size-control__btn font-size-control__btn--lg"
        onClick={increase}
        disabled={!canIncrease}
        title={`Aumentar fonte.`}
        aria-label="Aumentar fonte"
      >
        A+
      </button>
      <span className="visually-hidden" aria-live="polite">
        Tamanho da fonte: {sizePx} pixels
      </span>
    </div>
  );
}
